module.exports = {
  path: ':id',
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/DeviceBatchShow'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/app/routes/production/routes/deviceBatches/routes/show/index.js